import * as React from 'react';
export const IcPlanting = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.64 14.32a1 1 0 00-.82-.21 6.076 6.076 0 00-1.46.48 3.91 3.91 0 01-1.86.41 3.84 3.84 0 01-1.85-.41 5.837 5.837 0 00-1.65-.52V8.42c3.94-.62 4-4.87 4-4.92a.5.5 0 00-.5-.5A4.48 4.48 0 0012 5.81 4.48 4.48 0 007.5 3a.5.5 0 00-.5.5s.06 4.3 4 4.92v5.65a5.807 5.807 0 00-1.66.52A3.82 3.82 0 017.5 15a4 4 0 01-1.87-.41 5.838 5.838 0 00-1.45-.48 1 1 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1h16a1 1 0 001-1v-4.91a1.001 1.001 0 00-.36-.77z'
      fill='currentColor'
    />
  </svg>
);
